import { Tab, Tabs } from "@rothoblaas/design-system";
import { FC, type CSSProperties } from "react";
import { resolveAccentColor } from "../../../constants/colors";
import useI18n from "../../../hooks/useTranslations";
import { ModuleSettings } from "../../../http/types/modules";
import AdminNormativeTables from "./admin/AdminNormativeTables";
import AdminScrewDiameters from "./admin/AdminScrewDiameters";
import AdminScrewFamilies from "./admin/AdminScrewFamilies";
import AdminScrews from "./admin/AdminScrews";
import AdminTimberMaterials from "./admin/AdminTimberMaterials";
import AdminWashers from "./admin/AdminWashers";

interface ScrewConnectorAdminSettingsProps {
  moduleData: ModuleSettings;
}

const ScrewConnectorAdminSettings: FC<ScrewConnectorAdminSettingsProps> = ({ moduleData }) => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule;

  const tabs: Tab[] = [
    { title: t.tabs.screwFamilies },
    { title: t.tabs.screwDiameters },
    { title: t.tabs.screws },
    { title: t.tabs.washers },
    { title: t.tabs.timberMaterials },
    { title: t.tabs.normativeTables },
  ];

  return (
    <div style={{ "--accent-base": resolveAccentColor(moduleData.category?.color) } as CSSProperties}>
      <Tabs
        renderMode="eager"
        urlParameter="l_tab"
        tabs={tabs}
        contents={[
          <AdminScrewFamilies />,
          <AdminScrewDiameters />,
          <AdminScrews />,
          <AdminWashers />,
          <AdminTimberMaterials />,
          <AdminNormativeTables />,
        ]}
      />
    </div>
  );
};

export default ScrewConnectorAdminSettings;
